import {Component} from 'react'
import {ButtonContainer, ChoiceButton, ChoiceImage} from './styledComponents'

class GameView extends Component {
  render() {
    const {choicesList, onChoiceClick} = this.props
    return (
      <ButtonContainer>
        {choicesList.map(each => (
          <ChoiceButton
            key={each.id}
            data-testid={`${each.id.toLowerCase()}Button`}
            onClick={() => onChoiceClick(each.id)}
            style={{gridArea: each.id.toLowerCase()}}
          >
            <ChoiceImage src={each.imageUrl} alt={each.id} />
          </ChoiceButton>
        ))}
      </ButtonContainer>
    )
  }
}

export default GameView
